// TODO: Change to taptap customer

import { createSelector } from 'reselect';
import { RootState } from 'src/redux/store';

const selectTapTapCustomer = (state: RootState) => state.taptapCustomer;

const selectCustomers = createSelector(
  selectTapTapCustomer,
  (state) => state.taptapCustomers
);

const selectProfiles = createSelector(
  selectTapTapCustomer,
  (state) => state.taptapProfiles
);

const selectTaptapCustomerFilter = createSelector(
  selectTapTapCustomer,
  (state) => state.taptapGetCustomersPayload.filters
);

const selectTaptapCustomerColumns = createSelector(
  selectTapTapCustomer,
  (state) => state.taptapColumns
);

const selectTaptapOperationDashboardColumns = createSelector(
  selectTapTapCustomer,
  (state) => state.taptapOperationDashboardColumns
);

const selectTaptapCustomerNextPageLoading = createSelector(
  selectTapTapCustomer,
  (state) => state.isNextPageLoading
);

const selectTaptapCustomerLoading = createSelector(
  selectTapTapCustomer,
  (state) => state.isTapTapCustomersLoading
);

const selectTaptapCustomerSearchValue = createSelector(
  selectTapTapCustomer,
  (state) => state.taptapGetCustomersPayload.search || ''
);

const selectTaptapCustomerPayload = createSelector(
  selectTapTapCustomer,
  (state) => state.taptapGetCustomersPayload
);

const selectTapTapVersion = createSelector(
  selectTapTapCustomer,
  (state) => state.taptapVersion
);

const selectReports = createSelector(
  selectTapTapCustomer,
  (state) => state.taptapStatusReport
);

const selectReportsPayload = createSelector(
  selectTapTapCustomer,
  (state) => state.taptapStatusReportPayload
);

const selectReportsLoading = createSelector(
  selectTapTapCustomer,
  (state) => state.isTapTapReportsLoading
);

const selectForDeliveryCustomers = createSelector(
  selectTapTapCustomer,
  (state) => state.taptapCustomers.filter((c) => c.status === 'READY FOR DELIVERY')
);

const selectForPaymentCustomers = createSelector(
  selectTapTapCustomer,
  (state) => state.taptapCustomers.filter((c) => c.status === 'FOR PAYMENT')
);

export const selectors = {
  selectReports,
  selectProfiles,
  selectCustomers,
  selectTapTapVersion,
  selectReportsPayload,
  selectReportsLoading,
  selectForPaymentCustomers,
  selectForDeliveryCustomers,
  selectTaptapCustomerFilter,
  selectTaptapCustomerColumns,
  selectTaptapOperationDashboardColumns,
  selectTaptapCustomerLoading,
  selectTaptapCustomerPayload,
  selectTaptapCustomerSearchValue,
  selectTaptapCustomerNextPageLoading
};
